import './App.css';
import Header from './components/layout/Header';
import { Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './views/HomePage';
import MosaicsLine from './components/layout/MosaicsLine';
import Footer from './components/layout/Footer';
import { Lenis as ReactLenis, useLenis } from '@studio-freight/react-lenis';
import { useEffect, useState } from 'react';
import Contact from './views/Contact';
import Services from './views/Services';
import ContactPage from './views/ContactPage';
import About from './views/About';
import WorksPage from './views/WorksPage';
import Works from './views/Works';
import Work from './views/Work';
import clsx from 'clsx';
import PointerSelect from './components/layout/PointerSelect';
import BottomArrow from './components/assets/BottomArrow';
import { useMediaQuery } from 'react-responsive';
import Policy from './views/Policy';

function App() {
  // Optional: useLenis hook to control behavior
  const lenis = useLenis();
  const location = useLocation();

  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Fonction pour analyser le user agent
    const checkDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Liste des mots-clés communs pour identifier les appareils tactiles
      if (/android/i.test(userAgent)) {
        setIsTouchDevice(true); // Android est un appareil tactile
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setIsTouchDevice(true); // iOS est un appareil tactile
      } else {
        setIsTouchDevice(false); // Considéré comme un appareil non tactile
      }
    };

    checkDevice();
  }, []);

  const isMobile = useMediaQuery(
    {
      query: "(max-width: 780px)"
    }
  )

  const [customPointer, setCustomPointer] = useState((!isTouchDevice && !isMobile));


  function scrollToTop() {
    if (lenis) {
      lenis.scrollTo(0, { immediate: false });
    }
  }

  useEffect(() => {
    scrollToTop()
  }, [location]);


  return (
    <>
      <ReactLenis root options={{ smooth: true }}>
        <div className={clsx(
          'max-w-full',
          (customPointer && !isMobile) && "[&_*]:cursor-none"
        )} style={
          {
            overflowX: "clip"
          }
        }>
          <Header />
          <main>
            {["/"].includes(location.pathname) ?
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
              :
              <div className='mt-[105px] mobile:mt-[72px]'>
                <MosaicsLine />
                <Routes>
                  <Route path='/services' element={<Services />} />
                  <Route path='/contact' element={<ContactPage />} />
                  <Route path='/about' element={<About />} />
                  <Route path='/realisations' element={<WorksPage />} />
                  <Route path='/services/:service' element={<WorksPage />} />
                  <Route path='/realisations/:realisation' element={<Work />} />
                  <Route path='/politique-de-confidentialite' element={<Policy/>}/>
                </Routes>
              </div>}
          </main>
          <div className='mt-24'>
            <Contact />
          </div>
          <div className='mt-16'>
            <MosaicsLine />
            <div className='mobile:hidden'>
              <MosaicsLine reversed={true} />
            </div>
          </div>
          <Footer />
        </div>
      </ReactLenis>
      <div className='fixed bottom-8 right-8 z-[9999] flex flex-col gap-[1.5rem] items-center'>
        <button className={clsx(
          'w-[4.6875rem] h-[4.6875rem] bg-[rgba(0,0,0,0.2)] rounded-[100%] -scale-y-[1] text-white p-4',
          (customPointer && !isMobile) && "cursor-none"
        )} onClick={() => {
          scrollToTop();
        }}>
          <BottomArrow />
        </button>
        {(!isTouchDevice && !isMobile) && <PointerSelect defaultPointerCallback={setCustomPointer} />}
      </div>
    </>
  );
}

export default App;
